let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ok4B")).then(() => parcelRequire('2lAe5'));